import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { LoadAllOrders, LoadOrder, OrderAction, RefreshOrder } from './order.actions';
import { WorkService } from '../work.service';
import { tap } from 'rxjs';

export interface OrderStateModel {
  orders: any[];
  order?: any,
}

const defaults = {
  orders: []
};

@State<OrderStateModel>({
  name: 'order',
  defaults
})
@Injectable()
export class OrderState {

  constructor(private order: WorkService) {

  }

  @Action(LoadAllOrders)
  loadAllOrders({ patchState }: StateContext<OrderStateModel>) {
    return this.order.getOrders().pipe(
      tap((orders) => {
        patchState({ orders })
      })
    )
  }


  @Action(LoadOrder)
  loadOrder({ setState, patchState }: StateContext<OrderStateModel>, { id }: LoadOrder) {
    return this.order.getWorkOrder(id).pipe(
      tap((order) => {
        patchState({ order })
      })
    )
  }

  @Action(RefreshOrder)
  refreshOrder({ getState, patchState, dispatch }: StateContext<OrderStateModel>) {
    const { order } = getState();

    const actions = [];

    if (order.id) {
      actions.push(new LoadOrder(order.id))
    }

    return dispatch(actions);
  }


  @Selector()
  static orders(model: OrderStateModel) {
    return model.orders || [];
  }

  @Selector()
  static order(model: OrderStateModel) {
    return model.order;
  }
}
